import React from "react";
import {useSelector} from "react-redux";
import {selectField} from "../store/actions/fieldsActions";
import './FieldsList.scss';

import List from './_common/List';
import FieldModal from "./FieldModal";

const selector = state => {
    const { language, fields, modalState } = state;
    return {
        t: language.translator,
        selected: fields.selected,
        modalState: modalState
    }
};

const FieldsList = props => {
    const { fields, itemsCount, getFields } = props;
    const { page, pageCount, selected, modalState } = useSelector(selector);

    return (
        <div className='fieldsList'>
            <List
                roundTopCorners
                scroll
                items={fields}
                page={page}
                pageCount={pageCount}
                itemsCount={itemsCount}
                columnsNames={['Name', 'Avg Temp', 'Field Code', 'Orange Range', 'Red Range']}
                columns={['name', 'averageTemperature', 'fieldCode', 'orangeRange', 'redRange']}
                columnsWidths={['20%', '20%', '20%', '20%', '20%']}
                getItemsMethod={getFields}
                selectItemMethod={selectField}
                onSelectModalName='Edit field'
            />

            {(modalState.flag && modalState.modal === 'Edit field') &&
                <FieldModal
                    edit
                    field={selected.field}
                />
            }
        </div>
    );
};

export default FieldsList;
